import React from "react";
import Text from "./text";

const Email = React.forwardRef((props, ref) => {
    return (<Text type="email" {...props} ref={ref} />)
})

export default Email;